import './partials/base/init';
import {validateForm} from "./partials/base/validate-form";
import {tinySlider} from "./partials/base/carousel";
import {fixedMenu} from "./partials/base/fixed_menu";
import {aspect_ratio} from "./partials/base/aspect_ratio";
import {closeMenuFromLink, menu} from "./partials/base/menu";
import {excludeNumbers, numberOnly} from "./partials/base/helpers";
import {fixedHeaderMobile} from "./partials/legacy/fixed_menu";

window.onload = function() {
    menu();
    //closeMenuFromLink();
    validateForm();
    fixedMenu();
    fixedHeaderMobile();
    tinySlider();
    numberOnly();
    excludeNumbers();
    aspect_ratio('top_banner_ratio', 1920, 500);
    //aspect_ratio('post_fix_height', 4, 2.8, true);
    aspect_ratio('image_post_list', 3, 2, true);

};
window.onresize = function () {
    //tinySlider();
    fixedMenu();
    fixedHeaderMobile();
    //aspect_ratio('post_fix_height', 4, 2.8, true)
    aspect_ratio('image_post_list', 3, 2, true);
};
